import { ActionButton, MessageBarType } from "office-ui-fabric-react";
import React, { Component, Fragment, ReactElement } from "react";
import ReactJson from "react-json-view";
import { connect } from "react-redux";
import { DurableFunctionHistoryEvent } from "../../models/DurableFunctionHistoryEvent";
import Actions from "../../redux/Actions";
import { IRootState } from "../../store";
import DispatchProps from "../../utils/DispatchProps";
import ApiService from "../ApiService";
import Table, { TableColumn } from "../Table";
import TableCell from "../TableCell";

interface MailroomDurableFunctionInstanceHistoryProps {
    title: string;
    instanceId: string;
    linkForInstance?(o: any): string;


    apiService: ApiService;
}

interface MailroomDurableFunctionInstanceHistoryState {
    history: DurableFunctionHistoryEvent[] | undefined | null;
    historyJson?: any;
}

class MailroomDurableFunctionInstanceHistory extends Component<MailroomDurableFunctionInstanceHistoryProps & DispatchProps, MailroomDurableFunctionInstanceHistoryState>
{
    static columns: TableColumn[] = [
        { title: "Name", propertyPath: "Name", flex: 4 },
        { title: "Timestamp", propertyPath: "Timestamp", enableSort: true, type: "date", flex: 4 },
        { title: "", propertyPath: "View", flex: 4 },
    ];

    constructor(props: MailroomDurableFunctionInstanceHistoryProps & DispatchProps) {
        super(props);

        this.state = {
            history: undefined
        };
    }

    public async componentDidMount() {
        if (this.props.instanceId) {
            await this.load();
        }
    }

    async componentDidUpdate(prevProps: Readonly<MailroomDurableFunctionInstanceHistoryProps & DispatchProps>, prevState: any): Promise<void> {
        if (this.props.instanceId !== prevProps.instanceId) {
            await this.load();
        }
    }

    private async load() {
        try {
            this.setState({ history: undefined });
            let history = await this.props.apiService.getMailroomFunctionInstanceHistory(this.props.instanceId);
            this.setState({ history: history });
        }
        catch (e) {
            this.setState({ history: null });
            console.log(e);
            this.props.dispatch(Actions.showMessageBar(`Error loading upload history`, MessageBarType.error));
        }
    }

    private cellForColumn = (item: DurableFunctionHistoryEvent, column: TableColumn, columnIndex: number): ReactElement<TableCell> | undefined => {

        switch (column.propertyPath) {
            case "Name":
                return <TableCell key={columnIndex} flex={column.flex}>
                    <span>{item.FunctionName}</span>
                    <span className={"cdb-table__extra-detail"}>{item.EventType}</span>
                </TableCell>;

            case "View":
                return this.getViewButton(item);
            default:
                return undefined;
        }
    };

    private getViewButton(item: DurableFunctionHistoryEvent) {
        if (item.Input != undefined) {
            return <ActionButton iconProps={{ iconName: 'View' }} allowDisabledFocus disabled={false} checked={false} onClick={async () => { this.setState({ historyJson: item.Input }) }}>
                View Input
            </ActionButton>
        }

        if (item.Result != undefined) {
            return <ActionButton iconProps={{ iconName: 'View' }} allowDisabledFocus disabled={false} checked={false} onClick={async () => { this.setState({ historyJson: item.Result }) }}>
                View Result
            </ActionButton>
        }

        return <div style={{ minWidth: 114 }}></div>; /* Table spacing fix */
    }

    public render() {
        switch (this.state.history) {
            case null:
                return <div>Error loading upload history</div>
            default:
                return <Fragment>
                    <div className="flex-row">
                        <div className="flex-item--flex-1">
                            <Table
                                title={this.props.title}
                                items={this.state.history == undefined ? [] : this.state.history}
                                loading={this.state.history == undefined}
                                emptyMessage="No instance history"
                                columns={MailroomDurableFunctionInstanceHistory.columns}
                                cellForColumn={this.cellForColumn}
                                enableSort={true}>
                                {this.props.children}
                            </Table>
                        </div>
                        <div className="cdb-table flex-item--flex-1">
                            <div className="card__header">
                                <span className="card__title">
                                    Input/Result view
                                </span>
                            </div>
                            <div className="card__content">
                                {this.state.historyJson != undefined ? <ReactJson src={this.state.historyJson} theme="rjv-default" /> : null}
                            </div>
                        </div>
                    </div>
                </Fragment>
        }
    }
}



export default connect(
    (state: IRootState, ownProps: { title: string, instanceId: string, children?: any }): MailroomDurableFunctionInstanceHistoryProps => {
        return {
            title: ownProps.title,
            instanceId: ownProps.instanceId,
            apiService: state.auth.apiService
        };
    }
)(MailroomDurableFunctionInstanceHistory);